import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/30.mp3"
export default function P1() {
    return (
        <MainLayout
        title="Dlaczego chodzi sam wieczorem nad rzeczką?"     
        question="" 
            audio={audio}
        answers={{
            ans1: "Do widzenia!",
        }}
        links={{
            link1: PAGES.p57,
        }}
        content={
            <div>
                <ul>
                    <li>
                    Lubię te łąki. O, świerszczyk! Słyszysz?
                    </li>
                </ul>
                <p>
                Zastygasz i nasłuchujesz, ale słyszysz tylko gęganie. Na skrzyżowaniu dwóch polnych dróg widzisz kapliczkę Świętego Jana Nepomucena chroniącą od powodzi.
                </p>
            </div>
        }
        />
        
            );
}